import {
	SET_SEARCH,
	ON_EXPAND_TABLE,
	RESET_EXPANDED_ITEM,
	SET_SELECTED_ASSETS,
	SET_AVAILABLE_ASSETS,
	SET_SELECTED_STATUS,
	UPDATE_MANAGEMENTS,
	UPLOAD_REPORT,
	SET_AVAILABLE_STATUS,
	FILTER_REPORT_ATTACHED_ITEMS,
	FILTER_DIMISSED_ITEMS,
	SET_SELECTED_MANAGEMENTS,
	SET_ALL_ASSETS_SELECTED,
	ON_DATE_CHANGE

} from "./AlarmsLogActionsType.js";
import {
	GET,
	SET,
	RESET_STATE
} from "@/stores/CommumActionTypes";
import AlarmsTableFactory from "../../factories/AlarmsTableFactory.js";
import AlarmManagementStatus from "@/constants/enums/AlarmManagementStatus.js";

const mutations = {
	[GET]: (state) =>
	{
		state.logs = [];
		state.isLoadingTableData = true;
	},
	[SET]: (state, logs) =>
	{
		state.logs = logs;
		state.selectedTableRows = [];
		state.isLoadingTableData = false;
	},
	[SET_SELECTED_ASSETS]: (state, assets) =>
	{
		state.selectedAssets = assets;
	},
	[UPDATE_MANAGEMENTS]: (state, { resp, notificationLoggingId }) =>
	{
		const logIndex = state.logs.findIndex(el => el.notificationLoggingId === notificationLoggingId);
		if (logIndex !== -1)
		{
			state.logs[logIndex].lastManagement.managementType = resp.managementType;
			state.selectedTableRows = [];
		}
	},
	[UPLOAD_REPORT]: (state, resp) =>
	{
		const logIndex = state.logs.findIndex(el => el.notificationLoggingId === resp.notificationLoggingsId);
		if (logIndex !== -1)
		{
			state.logs[logIndex].lastManagement.managementType = AlarmManagementStatus.REPORT_ATTACHED;
			state.logs[logIndex].reports.push(resp);
		}
	},
	[SET_AVAILABLE_ASSETS](state, assets)
	{
		state.availableAssets = assets;
	},
	[SET_ALL_ASSETS_SELECTED](state, value)
	{
		state.allAssetsSelected = value;
	},
	[SET_SELECTED_STATUS]: (state, status) =>
	{
		state.selectedStatus = status;
	},
	[SET_SELECTED_MANAGEMENTS]: (state, managements) =>
	{
		state.selectedManagements = managements;
	},

	[FILTER_REPORT_ATTACHED_ITEMS]: (state) =>
	{
		state.logs = state.logs
			.filter(asset => asset.lastManagement.managementType === AlarmManagementStatus.REPORT_ATTACHED);
	},

	[FILTER_DIMISSED_ITEMS]: (state) =>
	{
		state.logs = state.logs
			.filter(asset => asset.lastManagement.managementType === AlarmManagementStatus.NONE);
	},
	[SET_AVAILABLE_STATUS](state, status)
	{
		state.availableStatus = status;
	},
	[SET_SEARCH]: (state, strSearch) =>
	{
		state.search = strSearch;
	},
	[ON_EXPAND_TABLE]: (state, event) =>
	{
		state.itemOnExpandedPanel = event.value ? [ event.item ] : [];
	},
	[RESET_STATE]: (state) =>
	{
		Object.assign(state, AlarmsTableFactory.StateEmpty());
	},
	[RESET_EXPANDED_ITEM]: (state) =>
	{
		state.itemOnExpandedPanel = [];
	},
	[ON_DATE_CHANGE]: (state, day) =>
	{
		state.dateTimeFilter = day;
	}
};

export default { mutations };